import { refreshPage } from "./helpers/refreshPage";

export default async function refreshSingleProductPage() {
    const iziPlaceholder = document.querySelector(".izi-widget-product");
    const iziButton = document.querySelector("inpost-izi-button");

    if (!iziPlaceholder && !iziButton) return;

    let productAddedToCart = false;
    let preventRefresh = false;
    let shadowObserver = null;

    let shouldRefresh = true;

    if (typeof InpostIziJavsscriptWoocommerce === "object") {
        shouldRefresh = InpostIziJavsscriptWoocommerce.refresh_after_add_to_cart;
    }

    const checkCountBadgeOnLoad = (iziButton) => {
        if (iziButton?.shadowRoot?.querySelector(".count-badge")) {
            refreshIfShould(shouldRefresh);
        }
    };

    const observeShadowRootBadge = (shadowRoot) => {
        if (shadowObserver) {
            shadowObserver.disconnect();
        }

        shadowObserver = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
                mutation.addedNodes.forEach((node) => {
                    if (node.nodeType !== Node.ELEMENT_NODE) return;

                    if (node.querySelector && node.querySelector(".count-badge")) {
                        productAddedToCart = false;
                        refreshIfShould(shouldRefresh);
                    }

                    if (node.classList.contains("product-count") && node.querySelector(".count-badge")) {
                        productAddedToCart = false;
                        refreshIfShould(shouldRefresh);
                    }
                });

                if (mutation.type !== "attributes" || !mutation.target.classList.contains("product-count")) return;

                if (mutation.target.querySelector(".count-badge")) {
                    productAddedToCart = false;
                    refreshIfShould(shouldRefresh);
                }
            });
        });

        shadowObserver.observe(shadowRoot, {
            childList: true,
            subtree: true,
            attributes: true,
        });
    };

    jQuery(document.body).on("added_to_cart", function () {
        productAddedToCart = true;

        const iziButton = document.querySelector("inpost-izi-button");

        if (!iziButton || !iziButton.shadowRoot) {
            return;
        }

        if (iziButton.shadowRoot.querySelector(".count-badge")) {
            productAddedToCart = false;
            refreshIfShould(shouldRefresh);
        } else {
            observeShadowRootBadge(iziButton.shadowRoot);
        }
    });

    const observer = new MutationObserver((mutationsList) => {
        mutationsList.forEach((mutation) => {
            mutation.addedNodes.forEach((node) => {
                if (node.id === "inpostpay-widget-popup") {
                    const shadowHost = document.querySelector(
                        "#inpostpay-widget-popup"
                    );
                    const shadowRoot = shadowHost.shadowRoot;

                    observeShadowRootBadge(shadowRoot);

                    shadowRoot.addEventListener("click", (event) => {
                        preventRefresh = event.target.id === "button-delete-binding";
                    });
                }
            });

            mutation.removedNodes.forEach((node) => {
                if (node.id !== "inpostpay-widget-popup") return;

                if (productAddedToCart && !preventRefresh) {
                    productAddedToCart = false;
                    refreshIfShould(shouldRefresh);
                }
            });
        });
    });

    function refreshIfShould(shouldRefresh) {
        if (shouldRefresh) {
            refreshPage();
        }
    }

    observer.observe(document.body, { childList: true, subtree: true });

    checkCountBadgeOnLoad(iziButton);
}
